import { Injectable } from "@angular/core";
declare var $: any;
declare var moment: any;

@Injectable({
  providedIn: "root"
})
export class DomService {
  constructor() {}

  scrolltosection(isPageLoad: boolean) {
    //console.info('Number of sections',$(".summary:visible").length)
    let DelayBeforeStartScroll = isPageLoad ? 500 : 0;
    setTimeout(function() {
      let animatedelay = $(".summary:visible").length > 3 ? 400 : 600;
      if ($(".section").length > 0) {
		$("html,body").scrollTop(0);
		const headerHeight = $('nav').outerHeight();
		const prevSectHeader = $(".section").offset().top - $(".collapseBlock.summary").outerHeight();
		const bodyScroll = ((headerHeight > prevSectHeader) ? ($(".section").offset().top) : prevSectHeader);
        $("html, body").animate(
          {
            scrollTop: bodyScroll
          },
          animatedelay
        );
      }
    }, DelayBeforeStartScroll);
  }

  scrollToFirstError() {
    //scroll to the first error field//
    let $err = $(".ng-invalid[formcontrolname]:eq(0)");
    if ($err.length > 0) {
      console.error($err[0]);
      setTimeout(function() {
        $("html, body").animate(
          {
            scrollTop: $err.offset().top
          },
          600
        );
      }, 100);
    }
  }

  initFlowLabels() {
	// $(".FlowupLabels").FlowupLabels();
	$('.FlowupLabels').FlowupLabels({
		// Handles the possibility of having input boxes prefilled on page load
		feature_onInitLoad: false,
		// Class when focusing an input
		class_focused: 'focused',
		// Class when an input has text entered
		class_populated: 'populated'
	});
  }

  hideAutoCompletePanels() {
    $(".mat-autocomplete-panel").hide();
  }
  showAutoCompletePanels() {
    $(".mat-autocomplete-panel").show();
  }
}
